<template>
  <v-layout>
    <v-btn
      @click="onClickSystem()"
      :class="{
        clickable: hasSystemNotification,
        unclickable: !hasSystemNotification,
      }"
      :color="color.system"
      :disabled="disabled"
    >
      <p class="button-text1">システム情報</p>
      <v-chip
        v-if="hasSystemNotification"
        class="count"
        color="#6699ff"
        text-color="white"
      >
        {{ unreadSystemNotificationCount }}
      </v-chip>
    </v-btn>
    <v-btn
      v-if="isHideRevenue === false"
      @click="onClickRequest()"
      :class="{
        clickable: hasRequestNotification,
        unclickable: !hasRequestNotification,
      }"
      :color="color.request"
      :disabled="disabled"
    >
      <p class="button-text2">審査情報</p>
      <v-chip
        v-if="hasRequestNotification"
        color="#6699ff"
        text-color="white"
        class="count"
      >
        {{ unreadRequestNotificationCount }}
      </v-chip>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: 'NotificationButtons',
  props: {
    unreadRequestNotificationCount: {
      type: Number,
      default: 0,
    },
    unreadSystemNotificationCount: {
      type: Number,
      default: 0,
    },
    color: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isHideRevenue: {
      type: Boolean,
      default: undefined,
    },
  },
  computed: {
    hasSystemNotification() {
      return this.unreadSystemNotificationCount > 0
    },
    hasRequestNotification() {
      return this.unreadRequestNotificationCount > 0
    },
  },
  methods: {
    onClickSystem() {
      this.$emit('onClickSystem', true, false)
    },
    onClickRequest() {
      this.$emit('onClickRequest', true, false)
    },
  },
}
</script>

<style scoped lang="scss">
.clickable {
  width: 40%;
  height: 30px;
  margin: 5px;
  cursor: pointer;
}
.unclickable {
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 40%;
  height: 30px;
}
.button-text1 {
  margin-top: 15px;
  margin-right: 15px;
}
.button-text2 {
  margin-top: 15px;
  margin-right: 15px;
}
.count {
  position: absolute;
  right: -19px;
  font-size: 10px;
  height: 16px;
  ::v-deep .v-chip__content {
    padding: 0 4px;
    justify-content: center;
    min-width: 16px;
  }
}
</style>
